import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, unref as _unref, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "user-login" }

import { reactive, ref } from "vue";
import { SmsControllerService, UserControllerService } from "../../generated";
import message from "@arco-design/web-vue/es/message";
import { useRouter } from "vue-router";
import { useStore } from "vuex";
import { IconEmail } from "@arco-design/web-vue/es/icon";


export default /*@__PURE__*/_defineComponent({
  __name: 'UserForgetView',
  setup(__props) {

const router = useRouter();
const store = useStore();
const form = reactive({
  userAccount: "",
  userPassword: "",
  checkPassword: "",
  userMail: "",
  verityCode: "",
} as any);
const trueCode = ref("654321");
const formRef = ref(null);
const verityCodeProps = ref({
  disabled: false,
  error: false,
  answer: "aaaaaa",
});
const getCode = async () => {
  if (!form.userMail || form.userMail === "") {
    message.error("请输入邮箱！");
  }
  const res = await SmsControllerService.sendMailForgetUsingPost(form);
  if (res.code === 0) {
    // 获取到验证码
    trueCode.value = res.data;
  }
};
const onFinish = (value: any) => {
  if (value !== trueCode.value) {
    verityCodeProps.value.error = true;
    message.error("验证码错误！");
    form.verityCode = "";
  } else {
    verityCodeProps.value.error = false;
    verityCodeProps.value.disabled = true;
  }
};
const handleSubmit = async () => {
  const redirectUrl = window.location.search;
  const res = await UserControllerService.resetPassWordUsingPost(form);
  if (res.code === 0) {
    await store.dispatch("user/getLoginUser");
    // 登录成功跳转页面
    // 重定向
    if (redirectUrl.startsWith("?redirect=")) {
      await router.push({
        path: redirectUrl.split("?redirect=")[1],
        replace: true,
      });
    } else {
      // 主页
      await router.push({
        path: "/",
        replace: true,
      });
    }
  } else {
    message.error("登录失败" + res.message);
  }
};
const rules = {
  userAccount: [
    {
      required: true,
      message: "请输入用户名！",
    },
  ],
  userPassword: [
    {
      required: true,
      message: "请输入密码！",
    },
  ],
  checkPassword: [
    {
      required: true,
      message: "请确认密码！",
    },
    {
      validator: (value: any, cb: any) => {
        if (value !== form.userPassword) {
          cb("two passwords do not match");
        } else {
          cb();
        }
      },
    },
  ],
  userMail: [
    {
      type: "email",
      required: true,
      message: "请输入邮箱！",
    },
  ],
  verityCode: [
    {
      required: true,
      message: "请输入验证码！",
    },
    {
      minLength: 6,
      message: "验证码未填完全！",
    },
    {
      match: /^\d+$/,
      message: "应为全数字！",
    },
  ],
};

return (_ctx: any,_cache: any) => {
  const _component_a_input = _resolveComponent("a-input")!
  const _component_a_form_item = _resolveComponent("a-form-item")!
  const _component_a_verification_code = _resolveComponent("a-verification-code")!
  const _component_a_button = _resolveComponent("a-button")!
  const _component_a_input_password = _resolveComponent("a-input-password")!
  const _component_a_form = _resolveComponent("a-form")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _cache[9] || (_cache[9] = _createElementVNode("h2", { style: {"margin-bottom":"32px"} }, "找回密码", -1)),
    _createVNode(_component_a_form, {
      ref_key: "formRef",
      ref: formRef,
      "label-align": 'right',
      layout: _ctx.horizontal,
      model: form,
      rules: rules,
      "auto-label-width": "",
      style: {"max-width":"480px","margin":"0 auto"},
      onSubmit: handleSubmit
    }, {
      default: _withCtx(() => [
        _createVNode(_component_a_form_item, {
          field: "userAccount",
          label: "用户名",
          tooltip: "请输入用户名"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_a_input, {
              modelValue: form.userAccount,
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((form.userAccount) = $event)),
              placeholder: "请输入用户名"
            }, null, 8, ["modelValue"])
          ]),
          _: 1
        }),
        _createVNode(_component_a_form_item, {
          field: "userMail",
          label: "邮箱",
          tooltip: "用于获取验证码"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_a_input, {
              modelValue: form.userMail,
              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((form.userMail) = $event)),
              placeholder: "example@mail.com"
            }, {
              prefix: _withCtx(() => [
                _createVNode(_unref(IconEmail))
              ]),
              _: 1
            }, 8, ["modelValue"])
          ]),
          _: 1
        }),
        _createVNode(_component_a_form_item, {
          field: "verityCode",
          label: "验证码",
          tooltip: "输入收到的验证码"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_a_verification_code, {
              modelValue: form.verityCode,
              "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((form.verityCode) = $event)),
              disabled: verityCodeProps.value.disabled,
              error: verityCodeProps.value.error,
              style: {"width":"300px"},
              onFinish: onFinish
            }, null, 8, ["modelValue", "disabled", "error"]),
            _createVNode(_component_a_button, {
              style: {"margin-left":"16px"},
              type: "primary",
              onClick: getCode
            }, {
              default: _withCtx(() => _cache[6] || (_cache[6] = [
                _createTextVNode("获取验证码 ")
              ])),
              _: 1
            })
          ]),
          _: 1
        }),
        _createVNode(_component_a_form_item, {
          field: "userPassword",
          label: "新密码",
          tooltip: "验证身份后解锁；密码不少于八位"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_a_input_password, {
              modelValue: form.userPassword,
              "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((form.userPassword) = $event)),
              disabled: !verityCodeProps.value.disabled,
              placeholder: "请输入密码"
            }, null, 8, ["modelValue", "disabled"])
          ]),
          _: 1
        }),
        _createVNode(_component_a_form_item, {
          field: "checkPassword",
          label: "确认密码",
          tooltip: "再次输入密码以确认"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_a_input_password, {
              modelValue: form.checkPassword,
              "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((form.checkPassword) = $event)),
              disabled: !verityCodeProps.value.disabled,
              placeholder: "请确认密码"
            }, null, 8, ["modelValue", "disabled"])
          ]),
          _: 1
        }),
        _createVNode(_component_a_form_item, null, {
          default: _withCtx(() => [
            _createVNode(_component_a_button, {
              "html-type": "submit",
              style: {"width":"150px","margin":"0 auto"},
              type: "primary"
            }, {
              default: _withCtx(() => _cache[7] || (_cache[7] = [
                _createTextVNode("重置密码 ")
              ])),
              _: 1
            }),
            _createVNode(_component_a_button, {
              style: {"width":"150px","margin":"0 auto"},
              type: "primary",
              onClick: _cache[5] || (_cache[5] = ($event: any) => (_unref(router).back()))
            }, {
              default: _withCtx(() => _cache[8] || (_cache[8] = [
                _createTextVNode("返回 ")
              ])),
              _: 1
            })
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["layout", "model"])
  ]))
}
}

})